import { memo, useCallback, useContext, useEffect, useState } from 'react'
import { TenantsContext } from '../../../context/tenants.context'
import SubirArchivo, { CasoRepiteID } from './SubirArchivo'
import AsignarColumnas from './AsignarColumnas'
import AsignarCategorias from './AsignarCategorias'
import { Box, Typography } from '@mui/material'
import {
  AtributoConValor,
  Atributos,
  Columna,
  CsvEquivalencia,
  Equivalencia,
  ImportarData,
  ResultadoFinal,
  RubroEquivalencia
} from './types/importacion'
import CloseButton, { CloseButtonProps } from '../../../components/CloseButton'
import { useStoreImportacion } from './store/store-importacion'
import AsignarAtributos from './AsignarAtributos'
import { ImportarCSV, SetCSVEquivalencias, SetRubrosEquivalencias } from '../services/impo-expo.service'
import { attributes, recorrerDataExcelYReemplazar, tieneValoresParaAsignar } from './utils/helpers'
import MensajeFinal from './MensajeFinal'
import { useAppStore } from '../../../store/app-store'
import SnackBarUtils from '../../../utils/SnackBarUtils'
import usePasos from './hooks/usePasos'
import { useResponsive } from '../../../hooks/useResponsive.hook'
import BotonesAtributos from './components/BotonesAtributos'
import { Atributo, AtributosEquivalencias, SaveValores } from '../types'
import {
  GetAtributosEquivalencias,
  GetAtributosEquivalenciasValoresBulk,
  SaveValoresAtributos
} from '../services/atributos.service'
import { RubroYValores } from './types/atributos'
import ButtonRounded from '../../../components/Common/utils/button/ButtonRounded'
import CustomStepper from '../../../components/Common/CustomStepper'
import useRubros from '../../Products/hooks/rubros.hook'
import { GruposAtributos, GruposList } from '../types/responses'
import { useDataABMRubros } from '../../Rubros/AbmRubros/services/datos.seleccion'
import { Rubro } from '../../Rubros/AbmRubros/types/rubro'

const Headers = [
  // 'SKU',
  'Nombre'
  //'Categoría',
  //'Moneda',
  //'Precio',
  //'Compra_mínima_por_mayor',
  //'Precio_anterior_sin_descuento',
  //'Precio_minorista',
  // 'Talles',
  // "Colores",
  // "Composición",
  // "Medida",
  // "Tamaño",
  //'Unidad_de_medida',
  //'Descripción'
  // 'ID'
]

export enum Pasos {
  SubirArchivo = 'Subir Archivo',
  AsignarColumnas = 'Asignar Columnas',
  AsignarCategorias = 'Asignar Categorias',
  AsignarAtributos = 'Asignar Atributos',
  ResultadoFinal = 'Resultado'
}

export enum PasosAtributos {
  Colores = 'Colores',
  Talles = 'Talles',
  Composiciones = 'Composicion',
  Medidas = 'Medida',
  Tamanos = 'Tamano'
}

export const CATEGORIA_NAME = 'codRubro'
export const TALLES_NAME = 'talles'

interface Props extends CloseButtonProps {
  getProducts: () => Promise<any[]>
}

const ImportarCatalogo = ({ closeButton, getProducts }: Props) => {
  const codLocal = useAppStore((state) => state.codLocal)
  const { tenant } = useContext(TenantsContext)
  const { isValid, loading, dataExcel, setIsValid, setLoading, setFile, setPercentage } = useStoreImportacion(
    (state) => state
  )
  const {
    paso,
    setPaso,
    handleBack,
    handleNext,
    reset: resetPaso
  } = usePasos({
    pasos: Object.values(Pasos),
    pasoInicial: Pasos.SubirArchivo
  })
  const {
    paso: pasoAtributos,
    setPaso: setPasoAtributos,
    handleBack: handleBackAttr,
    handleNext: handleNextAttr
  } = usePasos({
    pasos: Object.values(PasosAtributos),
    pasoInicial: PasosAtributos.Colores
  })
  const [dataToSend, setDataToSend] = useState<ImportarData[]>([])
  // Subir archivo
  const [casoRepiteIDs, setCasoRepiteIDs] = useState(CasoRepiteID.ReemplazaExistente)
  // Columnas
  const [columnas, setColumnas] = useState<Columna[]>([])
  const [columnasEquivalencias, setColumnasEquivalencias] = useState<Equivalencia[]>([])
  const [csvEquivalencias, setCsvEquivalencias] = useState<CsvEquivalencia[]>([])
  // Categorias
  const [categorias, setCategorias] = useState<string[]>([])
  const [categoriasEquivalencias, setCategoriasEquivalencias] = useState<Equivalencia[]>([])
  const [rubrosEquivalencias, setRubrosEquivalencias] = useState<RubroEquivalencia[]>([])
  // Atributos
  const [atributos, setAtributos] = useState<any>({})
  const [atributosEquivalencias, setAtributosEquivalencias] = useState<any[]>([])
  const [valoresList, setValoresList] = useState<AtributoConValor>()
  const [valoresASincronizar, setValoresASincronizar] = useState<SaveValores[]>([])
  // Mensaje Final
  const [resultado, setResultado] = useState<ResultadoFinal | null>(null)
  const { flatRubros } = useRubros()
  const { isMobile } = useResponsive()
  const [atributosTemplate, setAtributosTemplate] = useState<Atributo[]>([])
  const [atributosValores, setAtributosValores] = useState<AtributosEquivalencias[]>([])
  const [RubroYValores, setRubroYValores] = useState<RubroYValores[]>([])
  const { gruposAtr } = useDataABMRubros(false)

  const updateProgress = useCallback(
    (percentage: number | null) => {
      setPercentage(percentage)
    },
    [setPercentage]
  )

  const importar = useCallback(async () => {
    if (!flatRubros) return console.log('no hay rubros')
    if (!valoresList) return console.log('no hay valores list', { valoresList })

    const lineasAProcesar = dataExcel.length
    if (!window.confirm(`¿Estás seguro que deseás importar los datos? Se van a procesar ${lineasAProcesar} líneas.`))
      return

    // let newData: ImportarData[] = []
    // let hayData = true

    let newData: ImportarData[] = dataToSend.map((d) => {
      // inicializo todos los atributos en null
      const item = {
        ...d,
        talles: null,
        colores: null,
        composicion: null,
        medida: null,
        tamano: null
      }

      // 2) Obtengo las asignaciones que el usuario hizo para este rubro (puede ser [])
      const asignaciones = valoresList[item[CATEGORIA_NAME]] || []

      // 3) Agrupo esas asignaciones por atributo
      const porAtributo = asignaciones.reduce<Record<string, { nombre: string }[]>>((acc, v) => {
        if (!acc[v.atributo]) acc[v.atributo] = []
        acc[v.atributo].push({ nombre: v.nombre })
        return acc
      }, {})

      // 4) Busco el rubro correspondiente y, si existe, asigno sólo los atributos que haya
      const rubro = flatRubros.find((r) => r.codRubro === item[CATEGORIA_NAME])
      if (rubro) {
        if (porAtributo.talles?.length) {
          const attr = rubro.atributosPermitidos.find((a) => a.slug === 'talles')
          if (attr) item.talles = [{ ...attr, valoresList: porAtributo.talles }]
        }
        if (porAtributo.colores?.length) {
          const attr = rubro.atributosPermitidos.find((a) => a.slug === 'colores')
          if (attr) item.colores = [{ ...attr, valoresList: porAtributo.colores }]
        }
        if (porAtributo.composicion?.length) {
          const attr = rubro.atributosPermitidos.find((a) => a.slug === 'composicion')
          if (attr) item.composicion = [{ ...attr, valoresList: porAtributo.composicion }]
        }
        if (porAtributo.medida?.length) {
          const attr = rubro.atributosPermitidos.find((a) => a.slug === 'medida')
          if (attr) item.medida = [{ ...attr, valoresList: porAtributo.medida }]
        }
        if (porAtributo.tamano?.length) {
          const attr = rubro.atributosPermitidos.find((a) => a.slug === 'tamano')
          if (attr) item.tamano = [{ ...attr, valoresList: porAtributo.tamano }]
        }
      }

      return item
    })

    // Importar
    updateProgress(0)
    setLoading(true)

    try {
      let requestsCount = 1
      if (newData.length > 1 && newData.length <= 4) {
        requestsCount = 2
      } else if (newData.length > 4) {
        requestsCount = 4
      }

      const chunkSize = Math.ceil(newData.length / requestsCount)

      for (let i = 0; i < requestsCount; i++) {
        const start = i * chunkSize
        const end = start + chunkSize
        const newDataPart = newData.slice(start, end)

        // Realizar llamada a la API con la parte correspondiente de newData
        const res = await ImportarCSV(tenant.path, codLocal, newDataPart, casoRepiteIDs === CasoRepiteID.ReemplazaExistente)

        // Actualizar el estado con los datos de la llamada
        setResultado((prev: any) => {
          return {
            lineasErroneas: (prev?.lineasErroneas || 0) + res.data.data.lineasErroneas,
            lineasProcesadas: (prev?.lineasProcesadas || 0) + res.data.data.lineasProcesadas,
            lineasIgnoradas: (prev?.lineasIgnoradas || 0) + res.data.data.lineasIgnoradas,
            productosError: prev?.productosError
              ? prev.productosError.concat(res.data.data.productosError)
              : res.data.data.productosError
          }
        })

        // Actualizar el estado de la barra de progreso
        const progress = ((i + 1) / requestsCount) * 100
        updateProgress(progress)
        if (progress === 100) await new Promise((resolve) => setTimeout(resolve, 1500))
      }

      // Actualizar el estado de isValid y paso
      setIsValid(true)
      setPaso(Pasos.ResultadoFinal)

      // Actualizar el estado de loading a falso
      setLoading(false)

      // Actualizar los productos
      await getProducts()
      newData = []
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
      updateProgress(null)
    }
  }, [
    casoRepiteIDs,
    dataToSend,
    codLocal,
    valoresList,
    flatRubros,
    getProducts,
    setPaso,
    setLoading,
    setIsValid,
    updateProgress,
    dataExcel.length
  ])

  const setTemplateAtributosValores = useCallback(async () => {
    setLoading(true)

    try {
      const { data: dataAttrs } = await GetAtributosEquivalencias(tenant.path, codLocal)
      setAtributosTemplate(dataAttrs || null)

      if (dataAttrs) {
        const idsConEquivalencia = dataAttrs
          .filter((a) => a.idIntegracionAtributo !== 0)
          .map((a) => a.idIntegracionAtributo)

        if (idsConEquivalencia.length > 0) {
          const { data: valoresPorId } = await GetAtributosEquivalenciasValoresBulk(tenant.path, codLocal, idsConEquivalencia)
          const flat = Object.values(valoresPorId || {}).flat() as unknown as AtributosEquivalencias[]
          setAtributosValores(flat)
        } else {
          setAtributosValores([])
        }
      }
    } catch (error) {
      SnackBarUtils.error('Error al obtener el template')
    } finally {
      setLoading(false)
    }
  }, [codLocal, tenant.path])

  const sendCsvEquivalencias = useCallback(async () => {
    if (csvEquivalencias.length <= 0) return

    setLoading(true)
    try {
      const { data } = await SetCSVEquivalencias(tenant.path, codLocal, csvEquivalencias)
      setCsvEquivalencias([])
      SnackBarUtils.success(data.data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }, [codLocal, csvEquivalencias, setLoading])

  const sendRubrosEquivalencias = useCallback(async () => {
    if (rubrosEquivalencias.length <= 0) return

    setLoading(true)
    try {
      const { data } = await SetRubrosEquivalencias(tenant.path, codLocal, rubrosEquivalencias)
      setRubrosEquivalencias([])
      SnackBarUtils.success(data.data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }, [codLocal, rubrosEquivalencias, setLoading])

  const reset = useCallback(() => {
    setFile(null)
    setCategorias([])
    setColumnas([])
    setColumnasEquivalencias([])
    setCategoriasEquivalencias([])
    setCsvEquivalencias([])
    setRubrosEquivalencias([])
    setDataToSend([])
    setAtributosEquivalencias([])
    setAtributos({})
    setValoresList(null)
    setResultado(null)
    setPasoAtributos(PasosAtributos.Colores)
    resetPaso()
  }, [setFile, resetPaso, setPasoAtributos])

  const resetPartial = useCallback(() => {
    setCategorias([])
    setColumnas([])
    setColumnasEquivalencias([])
    setCategoriasEquivalencias([])
    setCsvEquivalencias([])
    setRubrosEquivalencias([])
    setDataToSend([])
    setAtributosEquivalencias([])
    setAtributos({})
    setValoresList(null)
    setResultado(null)
    setPasoAtributos(PasosAtributos.Colores)
    resetPaso()
  }, [resetPaso, setPasoAtributos])

  const checkContentDataIsValid = useCallback((dataExcel: any[]) => {
    let isValid = true
    if (dataExcel.length <= 0) {
      isValid = false
      return handleError({ error: 'Error al procesar el archivo' })
    }

    const headersError: string[] = []

    for (const row of dataExcel) {
      Headers.forEach((header) => {
        if (!row[header]) {
          isValid = false
          headersError.push(header)
        }
      })

      console.log({ row })

      // Si tiene todos los headers, entonces es valido
      if (isValid) {
        // Chequear que todos los productos tengan bien asignados el valor de Publicar
        if (!row.Publicar) {
          row.Publicar = false
        } else if (row.Publicar) {
          row.Publicar = true
        } else if (
          row.Publicar?.toUpperCase() === 'FALSO' ||
          row.Publicar?.toUpperCase() === 'FALSE' ||
          row.Publicar?.toUpperCase() === 'NO'
        ) {
          row.Publicar = false
        } else if (
          row.Publicar?.toUpperCase() === 'VERDADERO' ||
          row.Publicar?.toUpperCase() === 'TRUE' ||
          row.Publicar?.toUpperCase() === 'SI'
        ) {
          row.Publicar = true
        } else {
          row.Publicar = false
        }
      }
    }

    if (headersError.length > 0) {
      return handleError({
        error: `Revisa que todos los productos tengan ${[...new Set(headersError)]}`
      })
    }

    return isValid
  }, [])

  const handleAsignarColumnas = useCallback(() => {
    // Chequear contenido del archivo
    const dataValida = checkContentDataIsValid(dataExcel)
    if (!dataValida) return

    const allKeys = Array.from(new Set(dataExcel.flatMap((row) => Object.keys(row))))

    // Asignar columnas
    const columnas = allKeys.map((nombre) => {
      return {
        nombre,
        valor: nombre
      }
    })

    setColumnas(columnas)
  }, [dataExcel, reset])

  const handleAsignarCategorias = useCallback((): Promise<void> => {
    return new Promise((resolve) => {
      const categoria = columnasEquivalencias.find((eq) => Object.keys(eq)[0] === CATEGORIA_NAME)
      if (!categoria) {
        resolve()
        return
      }

      const nombreCategoria = categoria[CATEGORIA_NAME].value
      const indexedData = dataExcel.reduce(
        (acc, row) => {
          acc[row[nombreCategoria]] = row
          return acc
        },
        {} as Record<string, (typeof dataExcel)[number]>
      )

      const valoresCategoria = Object.keys(indexedData)

      setCategorias(valoresCategoria)
      resolve()
    })
  }, [columnasEquivalencias, dataExcel, setCategorias])

  const handleAsignarAtributos = useCallback(async () => {
    setLoading(true)

    try {
      const data = await recorrerDataExcelYReemplazar(dataExcel, columnasEquivalencias, categoriasEquivalencias)
      setDataToSend(data)

      const separador = /\s*[|,;\-]\s*/

      const atributosPromises = categoriasEquivalencias.map(async (eq) => {
        const categoria = Object.keys(eq)[0]
        const valor = eq[categoria].value

        const atributos = data
          .filter((row) => row[CATEGORIA_NAME] === valor)
          .reduce(
            (acc: { [key: string]: string[] }, row) => {
              const agregarAtributo = (campo: keyof typeof row, target: keyof typeof acc) => {
                if (row[campo]) {
                  const valores = String(row[campo])
                    .split(separador)
                    .map((t: string) => t.trim())
                  acc[target] = [...new Set([...acc[target], ...valores])]
                }
              }

              agregarAtributo('colores', 'colores')
              agregarAtributo('talles', 'talles')
              agregarAtributo('composicion', 'composicion')
              agregarAtributo('medida', 'medida')
              agregarAtributo('tamano', 'tamano')

              return acc
            },
            { colores: [], talles: [], composicion: [], medida: [], tamano: [] }
          )

        return { [valor]: atributos }
      })

      const atributosPorCategoria = await Promise.all(atributosPromises)

      await setTemplateAtributosValores()

      setAtributos(atributosPorCategoria)
      return atributosPorCategoria
    } catch (error) {
      console.error('Error al asignar atributos:', error)
    } finally {
      setLoading(false)
    }
  }, [categoriasEquivalencias, columnasEquivalencias, dataExcel, setLoading])

  const sincronizarValoresAtributos = useCallback(async () => {
    if (valoresASincronizar.length <= 0) return
    setLoading(true)
    try {
      await SaveValoresAtributos(tenant.path, valoresASincronizar, codLocal)
      SnackBarUtils.success('Valores sincronizados correctamente')
    } catch (error) {
      console.error('error', error)
    } finally {
      setLoading(false)
    }
  }, [])

  const handleNextImportacion = useCallback(
    async (paso) => {
      let callback = null
      switch (paso) {
        case Pasos.SubirArchivo:
          callback = handleAsignarColumnas
          break
        case Pasos.AsignarColumnas:
          await sendCsvEquivalencias()
          callback = await handleAsignarCategorias()
          break
        case Pasos.AsignarCategorias:
          callback = await handleAsignarAtributos()
          _setRubroYValores(callback)
          await sendRubrosEquivalencias()
          break
        case Pasos.ResultadoFinal:
          callback = reset()
          break
        default:
          break
      }
      if (paso !== Pasos.ResultadoFinal) {
        handleNext(callback)
        setIsValid(false)
      }
    },
    [
      handleAsignarAtributos,
      handleAsignarCategorias,
      handleAsignarColumnas,
      handleNext,
      reset,
      setIsValid,
      sendCsvEquivalencias,
      sendRubrosEquivalencias
    ]
  )

  const handleError = useCallback(
    ({ error }: { error: string }) => {
      // Si es un error de validación de headers, usar reset parcial para mantener el archivo
      if (error.includes('Revisa que todos los productos tengan')) {
        resetPartial()
      } else {
        reset()
      }
      SnackBarUtils.error(`Ocurrió un error al importar los datos${error ? ': ' + error : ''}`)
    },
    [reset, resetPartial]
  )

  const _setRubroYValores = useCallback(
    (atributos: Atributos[]) => {
      if (RubroYValores.length) return

      atributos.forEach((a) => {
        for (const key in attributes) {
          const { singular, plural } = attributes[key]
          const rubro = flatRubros.find((r) => Object.keys(a)[0] === r.codRubro.toString()) as Rubro
          const gruposList: GruposList[] = gruposAtr
            .flatMap((g: GruposAtributos) => g.grupos)
            .filter((grupo: GruposList) =>
              rubro?.atributosPermitidos?.some((a) => a.gruposPermitidos?.includes(grupo.idGrupo))
            )
          const attribute = rubro?.atributosPermitidos.find((a) => a.slug.toLowerCase() === singular.toLowerCase())

          if (attribute && gruposList) {
            const attrs = Object.values(a)[0][key]
            //const valores = attribute.gruposList.filter((v) => attrs.includes(v.nombre))

            if (
              !RubroYValores.some((r) => {
                return (
                  r.rubro.codRubro === rubro.codRubro &&
                  JSON.stringify(r.atributosDefault.all) === JSON.stringify(attribute) &&
                  JSON.stringify(r.atributosParaAsignar) === JSON.stringify(attrs)
                )
              })
            ) {
              RubroYValores.push({
                rubro: {
                  codRubro: rubro.codRubro,
                  nombre: rubro.nombreAnalytics
                },
                atributosDefault: {
                  key,
                  all: attribute,
                  valores: gruposList
                },
                atributosParaAsignar: attrs
              })
            }
          }
        }
      })

      const r = RubroYValores.filter((r) => r.atributosParaAsignar.length > 0)
      setRubroYValores(r)
      return r
    },
    [RubroYValores, flatRubros]
  )

  useEffect(() => {
    if (!atributos || !RubroYValores?.length) return

    const primerPasoDisponible = Object.values(PasosAtributos).find((p) =>
      tieneValoresParaAsignar(atributos, p, RubroYValores)
    )

    if (primerPasoDisponible && primerPasoDisponible !== pasoAtributos) {
      setPasoAtributos(primerPasoDisponible)
    }
  }, [atributos, RubroYValores])

  return (
    <Box display="flex" flexDirection="column" gap="24px" width="100%">
      <Box
        width="100%"
        display="flex"
        justifyContent={paso === Pasos.ResultadoFinal ? 'flex-end' : 'space-between'}
        alignItems="center"
      >
        <Typography
          hidden={paso === Pasos.ResultadoFinal}
          fontSize={{ xs: 20, md: 24 }}
          fontWeight={'bold'}
          color="#1C1C1C"
        >
          Importar Catálogo
        </Typography>
        {closeButton && <CloseButton onClick={() => closeButton(paso, reset)} disabled={loading} />}
      </Box>
      {/* Stepper Desktop */}
      {!isMobile && paso !== Pasos.ResultadoFinal && (
        <CustomStepper
          length={Object.values(Pasos).length}
          values={Object.values(Pasos)}
          active={Object.values(Pasos).indexOf(paso as Pasos)}
        />
      )}
      {paso === Pasos.SubirArchivo && <SubirArchivo setCasoRepiteIDs={setCasoRepiteIDs} />}
      {paso === Pasos.AsignarColumnas && (
        <AsignarColumnas
          columnas={columnas}
          equivalencias={columnasEquivalencias}
          setEquivalencias={setColumnasEquivalencias}
          csvEquivalencias={csvEquivalencias}
          setCsvEquivalencias={setCsvEquivalencias}
        />
      )}
      {paso === Pasos.AsignarCategorias && (
        <AsignarCategorias
          categorias={categorias}
          equivalencias={categoriasEquivalencias}
          setEquivalencias={setCategoriasEquivalencias}
          rubrosEquivalencias={rubrosEquivalencias}
          setRubrosEquivalencias={setRubrosEquivalencias}
          handleNextImportacion={handleNextImportacion}
          paso={paso}
        />
      )}
      +
      {paso === Pasos.AsignarAtributos && (
        <AsignarAtributos
          gruposAtr={gruposAtr}
          paso={pasoAtributos}
          atributos={atributos}
          equivalencias={atributosEquivalencias}
          setEquivalencias={setAtributosEquivalencias}
          handleNext={handleNextAttr}
          valoresList={valoresList}
          setValoresList={setValoresList}
          setValoresASincronizar={setValoresASincronizar}
          atributosValores={atributosValores}
        />
      )}
      {paso === Pasos.ResultadoFinal && <MensajeFinal resultado={resultado} dataToSend={dataToSend} />}
      {isMobile && paso !== Pasos.ResultadoFinal && (
        <CustomStepper
          length={Object.values(Pasos).length}
          values={Object.values(Pasos)}
          active={Object.values(Pasos).indexOf(paso as Pasos)}
        />
      )}
      <Box display="flex" justifyContent="space-between" width="100%" gap={'12px'}>
        {/* Botones de navegación IMPORTACION */}
        <Box
          display="flex"
          flexDirection={
            paso === Pasos.ResultadoFinal && resultado && resultado.lineasErroneas <= 0 ? 'row-reverse' : 'row'
          }
          gap={isMobile ? '10px' : '24px'}
          justifyContent="space-between"
          alignItems="center"
          width={paso !== Pasos.AsignarAtributos ? '100%' : 'auto'}
          hidden={paso === Pasos.AsignarAtributos && pasoAtributos !== PasosAtributos.Colores}
        >
          <ButtonRounded
            hidden={
              paso === Pasos.SubirArchivo ||
              (paso === Pasos.AsignarAtributos && pasoAtributos !== PasosAtributos.Colores)
            }
            disabled={loading}
            bgcolor={paso === Pasos.ResultadoFinal && resultado.lineasErroneas === 0 ? '#5983EF' : 'transparent'}
            textColor={paso === Pasos.ResultadoFinal && resultado.lineasErroneas === 0 ? 'white' : '#5983EF'}
            onClick={() => {
              if (paso === Pasos.ResultadoFinal) closeButton && closeButton(paso, reset)
              else handleBack()
            }}
            sx={{ minWidth: '160px' }}
            fullWidth={isMobile || (paso === Pasos.ResultadoFinal && resultado.lineasErroneas === 0)}
          >
            {paso === Pasos.ResultadoFinal ? 'Cerrar' : 'Volver'}
          </ButtonRounded>
          <ButtonRounded
            hidden={paso === Pasos.AsignarAtributos}
            bgcolor={paso === Pasos.ResultadoFinal && resultado.lineasErroneas === 0 ? 'transparent' : '#5983EF'}
            textColor={paso === Pasos.ResultadoFinal && resultado.lineasErroneas === 0 ? '#5983EF' : 'white'}
            disabled={!isValid || loading}
            onClick={() => handleNextImportacion(paso)}
            fullWidth={
              isMobile ||
              paso !== Pasos.ResultadoFinal ||
              (paso === Pasos.ResultadoFinal && resultado.lineasErroneas > 0)
            }
            sx={{ minWidth: '250px' }}
          >
            {paso === Pasos.ResultadoFinal ? 'Volver a importar' : loading ? 'Cargando...' : 'Continuar'}
          </ButtonRounded>
        </Box>
        {/* Botones de navegación ATRIBUTOS */}
        {paso === Pasos.AsignarAtributos && (
          <BotonesAtributos
            setPaso={setPasoAtributos}
            callback={importar}
            sincronizar={sincronizarValoresAtributos}
            loading={loading}
            paso={paso}
            pasoAtributos={pasoAtributos}
            atributos={atributos}
            loadingTextButton="Importando"
            textButton="Finalizar e Importar"
            RubroYValores={RubroYValores}
            handleBack={handleBack}
          />
        )}
      </Box>
    </Box>
  )
}

export default memo(ImportarCatalogo)
